

if(window.TELSA === undefined) {
    window.TELSA = {};
}


window.TELSA.loading = function(turnOn) {
    if (turnOn) {
        document.getElementById("loading-overlay").style.display = "inherit";
    } else {
        document.getElementById("loading-overlay").style.display = "none";
    }
};

//TELSA.moment = require('moment');
TELSA.moment = require('moment-timezone');
TELSA.hash = require('object-hash');

TELSA.decodeJwt = function(jwt) {
    const jwtParts = jwt.split('.');
    return {
        jwtHeader: JSON.parse(atob(jwtParts[0])),
        jwtPayload: JSON.parse(atob(jwtParts[1])),
    }
};

TELSA.isTokenExpired = function(jwt) {
    let jwtParts = jwt.split('.');
    let jwtHeader, jwtPayload;
    try {
        jwtHeader = JSON.parse(atob(jwtParts[0]));
        jwtPayload = JSON.parse(atob(jwtParts[1]));
    } catch(e) {
        return true;
    }
    if(jwtPayload.exp < Math.round(Date.now() / 1000)) {
        return true;
    }
    return false;
};

TELSA.getLengthOfTimeFriendlyName = function(unixTimestamp) {
    let timeDiffSec = ((Date.now() - unixTimestamp) / 1000);
    let threeDaysSec = 259200;
    let twoHoursSec = 7200;
    let secInDay = 86400;
    let secInHour = 3600;

    if(timeDiffSec > threeDaysSec) {
        return `${Math.round((timeDiffSec / secInDay) * 10) / 10} days`;
    }
    else if(timeDiffSec > twoHoursSec) {
        return `${Math.round((timeDiffSec / secInHour) * 10) / 10} hours`;
    }
    else {
        return `${Math.round(timeDiffSec / 60)} min`;
    }
};

TELSA.readableFileSize = function(size) {
    let units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let i = 0;
    while(size >= 1024) {
        size /= 1024;
        ++i;
    }
    return size.toFixed(1) + ' ' + units[i];
};

TELSA.fileToBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
});

TELSA.convertMilisecondsToReadableDuration = function(miliseconds, format) {
    let days, hours, minutes, seconds, total_hours, total_minutes, total_seconds;
    
    total_seconds = parseInt(Math.floor(miliseconds / 1000));
    total_minutes = parseInt(Math.floor(total_seconds / 60));
    total_hours = parseInt(Math.floor(total_minutes / 60));
    days = parseInt(Math.floor(total_hours / 24));

    seconds = parseInt(total_seconds % 60);
    minutes = parseInt(total_minutes % 60);
    hours = parseInt(total_hours % 24);
    
    switch(format) {
        case 's':
            return total_seconds;
        case 'm':
            return total_minutes;
        case 'h':
            return total_hours;
        case 'd':
            return days;
        default:
            return { d: days, h: hours, m: minutes, s: seconds };
    }
};

TELSA.arrayEqualCheck = function(arr1, arr2) {
    if(arr1 === null || arr2 === null) {
        return false;
    }
    if(arr1.length != arr2.length) {
        return false;
    }
    for(let [idx, val] of arr1.entries()) {
        if(val != arr2[idx]) {
            return false;
        }
    }
    return true;
};

TELSA.checkPermission = function(user, attemptedFunction) {
    if(user.user_data && user.user_data.is_customer_admin) {
        return true;
    }

    let userPermissions = user.user_permissions;
    let allow = false;
    let deny = false;
    let regexIsMatch = function(strA, strB) {
        return !!strA.match(strB);
    }

    for(let permission of userPermissions) {
        if(permission.perm_action == 'ALLOW' && regexIsMatch(attemptedFunction, '^' + permission.perm_function.replace("*", ".*"))) {
            allow = true;
        }
        else if(permission.perm_action == 'DENY' && regexIsMatch(attemptedFunction, '^' + permission.perm_function.replace("*", ".*"))) {
            deny = true;
        }
    }

    return (allow && !deny);
};

TELSA.checkPermissionQualifier = function(user, functionName, attemptedQualifier, defaultAllow=false) {
    if(user.user_data && user.user_data.is_customer_admin) {
        return true;
    }
    
    let userPermissions = user.user_permissions;
    let allow = false;
    let deny = false;
    let regexIsMatch = function(strA, strB) {
        return !!strA.match(strB);
    }

    let matchingPermissionsList = userPermissions.filter(p => {
        return regexIsMatch(functionName, p.perm_function.replace("*", ".*") + '$');
    });

    for(let permission of matchingPermissionsList) {
        if(permission.perm_action == 'ALLOW' && regexIsMatch(attemptedQualifier, permission.perm_qualifier.replace("*", ".*") + '$')) {
            allow = true;
        }
        else if(permission.perm_action == 'DENY' && regexIsMatch(attemptedQualifier, permission.perm_qualifier.replace("*", ".*") + '$')) {
            deny = true;
        }
    }

    return ((allow || defaultAllow) && !deny);
};


TELSA.waitUntil = async function(condition, timeoutSec) {
    let iterationMS = 25;
    let totalTime = 0;
    //console.log('condition: ', !!condition);
    while(!condition() && totalTime < timeoutSec) {
        await TELSA.sleep(iterationMS);
        totalTime += iterationMS;
        // console.log('condition: ', !!condition());
        // console.log('totalTime: ', totalTime);
    }
};

TELSA.sleep = async function(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
};

TELSA.getFileIcon = function(fileName) {
    let fe = fileName.split('.').pop();

    if(fe == "pdf") {
        return "mdi-file-pdf";
    }
    else if(fe == "txt") {
        return "mdi-file-document";
    }
    else if(fe == "docx" || fe == "docm" || fe == "doc") { // MS Word
        return "mdi-file-word";
    }
    else if(fe == "xls" || fe == "xlt" || fe == "xlsx" || fe == "xlsm" || fe == "xltx" || fe == "xlm" || fe == "ods") { // MS Excel
        return "mdi-file-excel";
    }
    else if(fe == "ppt" || fe == "pot" || fe == "pps") { // MS PPT
        return "mdi-file-powerpoint";
    }
    else if(fe == "aif" || fe == "cda" || fe == "mid" || fe == "midi" || fe == "mp3" || fe == "mpa"
            || fe == "ogg" || fe == "wav" || fe == "wma" || fe == "wpi") { // Audio
        return "mdi-file-music";
    }
    else if(fe == "ai" || fe == "bmp" || fe == "gif" || fe == "ico" || fe == "jpeg" || fe == "jpg"
            || fe == "png" || fe == "ps" || fe == "psd" || fe == "svg" || fe == "tif" || fe == "tiff") { // Image
        return "mdi-file-image";
    }
    else if(fe == "3g2" || fe == "3gp" || fe == "avi" || fe == "flv" || fe == "h264" || fe == "m4v" || fe == "wmv"
            || fe == "mkv" || fe == "mov" || fe == "mp4" || fe == "mpg" || fe == "mpeg" || fe == "swf") { // Video
        return "mdi-file-video";
    }
    else if(fe == "c" || fe == "cgi" || fe == "pl" || fe == "class" || fe == "cpp" || fe == "cs" || fe == "h" || fe == "css" || fe == "html"
            || fe == "java" || fe == "php" || fe == "py" || fe == "py" || fe == "sh" || fe == "swift" || fe == "vb" || fe == "js") { // Code
        return "mdi-file-code";
    }
    else {
        return "mdi-file";
    }
};

TELSA.convertHexColorToRGB = function(hexStr) {
    let color = {};
    color.r = parseInt(hexStr.substr(1,2),16);
    color.g = parseInt(hexStr.substr(3,2),16);
    color.b = parseInt(hexStr.substr(5,2),16);
    return color;
};

TELSA.convertHexColorToHSL = function(hexStr) {
    let rgbColor = TELSA.convertHexColorToRGB(hexStr);
    // Make r, g, and b fractions of 1
    let r = rgbColor.r /= 255;
    let g = rgbColor.g /= 255;
    let b = rgbColor.b /= 255;

    let max = Math.max(r, g, b), min = Math.min(r, g, b);
    let h, s, l = (max + min) / 2;

    if(max == min) {
        h = s = 0; // achromatic
    } 
    else {
        let d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }

    s = s*100;
    s = Math.round(s);
    l = l*100;
    l = Math.round(l);
    h = Math.round(360*h);

    return {h: h, s: s, l: l};
};

TELSA.isValidRGB = function(str) {
    return /^(\d{1,3}) (\d{1,3}) (\d{1,3})$/.test(str) && str.split(' ').every(num => +num <= 255);
};


TELSA.convertRGBToHexColor = function(rgbStr) {
    let [r, g, b] = rgbStr.split(' ').map(num => parseInt(num, 10));
    let hex = "#";
    hex += r.toString(16).padStart(2, '0');
    hex += g.toString(16).padStart(2, '0');
    hex += b.toString(16).padStart(2, '0');
    return hex;
};



TELSA.arrayGroupBy = function(objectArray, property) {
    return objectArray.reduce((acc, obj) => {
        const key = obj[property];
        if (!acc[key]) {
            acc[key] = [];
        }
        // Add object to list for given key's value
        acc[key].push(obj);
        return acc;
    }, {});
};

TELSA.arrayToDict = function(objectArray, key) {
    let mapped = objectArray.map(item => ({ [item[key]]: item }) );
    return Object.assign({}, ...mapped );
};

TELSA.buf2hex = function(buffer) { // buffer is an ArrayBuffer
    return [...new Uint8Array(buffer)]
        .map(x => x.toString(16).padStart(2, '0'))
        .join('');
};

TELSA.hex2buf = function(hexStr) {
    return new Uint8Array(hexStr.match(/[\da-f]{2}/gi).map(function (h) {
        return parseInt(h, 16)
    }));
};

TELSA.upperFirstCharacter = function(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

TELSA.getFileName = function(str) {
    const lastDotIndex = str.lastIndexOf('.');
    if (lastDotIndex !== -1) {
        return str.substring(0, lastDotIndex);
    } else {
        return str;
    }
};

TELSA.getFileType = function(str) {
    const lastDotIndex = str.lastIndexOf('.');
    if (lastDotIndex !== -1) {
        return str.substring(lastDotIndex + 1).trim(); // trim to remove leading spaces
    } else {
        return '';
    }
};



//// INDEXED DB ////
TELSA.IDB_VERSION = 4;

TELSA.IDB = {
	initialize(stores) {
		return new Promise((resolve, reject) => {
			// Then creates a new one
            let request = indexedDB.open('telsa', TELSA.IDB_VERSION);
			request.onupgradeneeded = function() {
                // IN UPGRADE AREA
                let db = request.result;
                let existingStoreNames = db.objectStoreNames;
                for(let store of stores) {
                    if(!existingStoreNames || !existingStoreNames.contains(store.name)) {
                        let objectStore = db.createObjectStore(store.name);
                        for(let index of store.indexes) {
                            objectStore.createIndex(index.indexName, index.indexProperty, { unique: index.unique });
                        }
                    }
                }
				resolve();
			}
			request.onerror = function() {
                // Error
				reject(request.error);
            }
            request.onsuccess = function() {
                // IN SUCCESS AREA
                // let existingStoreNames = request.result.objectStoreNames;
                // for(let store of stores) {
                //     if(!existingStoreNames || !existingStoreNames.contains(store.name)) {
                //         request.result.createObjectStore(store.name);
                //     }
                // }
            }
		});
	},

	get(store, key) {
		return new Promise((resolve, reject) => {
			let oRequest = indexedDB.open('telsa');
			oRequest.onsuccess = function() {
				let db = oRequest.result;
                let tx = db.transaction(store, 'readonly');
				let st = tx.objectStore(store);
				let gRequest = st.get(key);
				gRequest.onsuccess = function() {
					resolve(gRequest.result);
				}
				gRequest.onerror = function() {
					reject(gRequest.error);
				}
			}
			oRequest.onerror = function() {
				reject(oRequest.error);
			}
		});
    },
    
    getAll(store) {
		return new Promise((resolve, reject) => {
			let oRequest = indexedDB.open('telsa');
			oRequest.onsuccess = function() {
				let db = oRequest.result;
                let tx = db.transaction(store, 'readonly');
				let st = tx.objectStore(store);
				let gRequest = st.getAll();
				gRequest.onsuccess = function() {
					resolve(gRequest.result);
				}
				gRequest.onerror = function() {
					reject(gRequest.error);
				}
			}
			oRequest.onerror = function() {
				reject(oRequest.error);
			}
		});
	},

    getAllKeys(store) {
        return new Promise((resolve, reject) => {
            let oRequest = indexedDB.open('telsa');
            oRequest.onsuccess = function() {
                let db = oRequest.result;
                let tx = db.transaction(store, 'readonly');
                let st = tx.objectStore(store);
                let keysRequest = st.getAllKeys(); // Using getAllKeys() to retrieve all keys
                keysRequest.onsuccess = function() {
                    resolve(keysRequest.result); // Resolving the promise with the list of keys
                }
                keysRequest.onerror = function() {
                    reject(keysRequest.error); // Rejecting the promise if an error occurs
                }
            }
            oRequest.onerror = function() {
                reject(oRequest.error); // Rejecting the promise if the IndexedDB open request fails
            }
        });
    },

    getAllViaIndex(store, indexName, indexValue) {
        return new Promise((resolve, reject) => {
            let oRequest = indexedDB.open('telsa');
            oRequest.onsuccess = function() {
                let db = oRequest.result;
                let tx = db.transaction(store, 'readonly');
                let st = tx.objectStore(store);
                let index = st.index(indexName);
                let indexRequest = index.getAll(indexValue);
                indexRequest.onsuccess = function () {
                    resolve(indexRequest.result);
                };
                
            }
            oRequest.onerror = function() {
                reject(oRequest.error); // Rejecting the promise if the IndexedDB open request fails
            }
        });

    },

	set(store, key, value) {
		return new Promise((resolve, reject) => {
			let oRequest = indexedDB.open('telsa');
			oRequest.onsuccess = function() {
				let db = oRequest.result;
                let tx = db.transaction(store, 'readwrite');
				let st = tx.objectStore(store);
				let sRequest = st.put(value, key);
				sRequest.onsuccess = function() {
					resolve();
				}
				sRequest.onerror = function() {
					reject(sRequest.error);
				}
			}
			oRequest.onerror = function() {
				reject(oRequest.error);
			}
		});
	},

	remove(store, key) {
		return new Promise((resolve, reject) => {
			let oRequest = indexedDB.open('telsa')
			oRequest.onsuccess = function() {
				let db = oRequest.result;
                let tx = db.transaction(store, 'readwrite');
				let st = tx.objectStore(store);
				let rRequest = st.delete(key);
				rRequest.onsuccess = function() {
					resolve();
				}
				rRequest.onerror = function() {
					reject(rRequest.error);
				}
			}
			oRequest.onerror = function() {
				reject(oRequest.error);
			}
		});
	},

    createIndex(storeName, indexName, indexProperty, unique) {
        return new Promise((resolve, reject) => {
            let oRequest = indexedDB.open('telsa');
            
            oRequest.onsuccess = function() {
                let db = oRequest.result;
                
                // Check if the store exists
                if (!db.objectStoreNames.contains(storeName)) {
                    return reject(new Error(`Store "${storeName}" does not exist.`));
                }
                let transaction = db.transaction(storeName, 'readwrite');
                let store = transaction.objectStore(storeName);
                // Check if the index already exists
                if (store.indexNames.contains(indexName)) {
                    return resolve(`Index "${indexName}" already exists.`);
                }
                // Create the index
                store.createIndex(indexName, indexProperty, { unique: unique });
                transaction.oncomplete = function() {
                    resolve(`Index "${indexName}" created successfully.`);
                };
                transaction.onerror = function() {
                    reject(transaction.error);
                };
            };
        
            oRequest.onerror = function() {
                reject(oRequest.error);
            };
        });
    }
}

